import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


const TicketAttachments = gql`
  query TicketAttachments($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      ticket_number {
        id
        document {
          id
          attachments {
            edges {
              node {
                id
                description
                downloadUrl: download_url
                pageNumber: page_number
              }
            }
          }
        }
      }
    }
  }
`;


const withTicketAttachmentsData = graphql(TicketAttachments);


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const attachments = querySelector(data, '$.ticket.ticket_number.document.attachments.edges[*].node', []);

  return {
    attachments,
  };
});


export const withTicketAttachments = compose(
  withTicketAttachmentsData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export const updateCachedTicketAttachments = async (client, ticketId) => {
  const variables = {
    ticketId,
  };

  const { data } = await client.query({
    query: TicketAttachments,
    variables,
    fetchPolicy: 'network-only',
  });
  client.writeQuery({ query: TicketAttachments, variables, data });
};
